import { createTheme } from '@mui/material'
import { mergeDeepRight } from 'ramda'
import { Theme as _Theme } from 'styled-system'

const darks = ['#2C2F3C', '#404360', '#60637D', '#7F849D', '#9D9EB6']
const lights = ['#D4D6E3', '#E9E9F0', '#F0F2F6', '#F9FAFC', '#FCFCFD']

export const optiosTheme = {
  colors: {
    primary: '#005cdb',
    error: '#d24444',
    destructive: '#d24444',
    danger: '#d24444',
    errorLight: '#f58787',
    success: '#69d321',
    info: '#2164db',
    link: '#2164db',
    warning: '#fbb03b',
    warningLight: '#f7c26f',
    shadow: darks[0],
    border: darks[4],
    darks,
    lights,
    typography: darks,
    surfaces: lights,
  },
  card: {
    borderRadius: 8,
  },
  fontFamily: 'proxima-nova, sans-serif',
  breakpoints: { sm: '0em', md: '40em', lg: '64em', xlg: '80em' },
  space: [0, 8, 16, 24, 32, 48, 64, 128, 256, 512],
}

export const theme = mergeDeepRight(optiosTheme, createTheme())

type OptiosTheme = typeof theme
type OptiosColors = OptiosTheme['colors']
export type { OptiosTheme as Theme, OptiosColors as Colors }
